import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useStore } from "../../context/StoreContext";
import { eur, packTotal } from "../../lib/format";

export const StickyATC = () => {
  const { selectedPack, openCart, cartOpen } = useStore();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!selectedPack) return null;

  return (
    <AnimatePresence>
      {visible && !cartOpen && (
        <motion.div
          data-testid="sticky-atc-bar"
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-zinc-200 px-4 py-3 flex items-center gap-3"
          style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
        >
          <div className="flex-1 min-w-0">
            <p className="text-xs text-zinc-500 truncate">{selectedPack.name}</p>
            <p className="font-display font-bold text-base leading-tight">{eur(packTotal(selectedPack))}</p>
          </div>
          <button
            data-testid="sticky-atc-button"
            onClick={() => openCart()}
            className="bg-brand active:bg-brand-dark text-white font-display font-bold text-sm rounded-full px-7 py-3.5 shadow-md shadow-brand/30"
          >
            I WANT IT
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
